'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const reactPopper = require('react-popper');
const useClickOutside = require('../hooks/useClickOutside.js');
const popover_style = require('./popover.style.js');

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var PopperComponent = function PopperComponent(_ref) {
  var _ref$showArrow = _ref.showArrow,
    showArrow = _ref$showArrow === void 0 ? true : _ref$showArrow,
    theme = _ref.theme,
    referenceElement = _ref.referenceElement,
    popoverOffset = _ref.popoverOffset,
    _ref$preventOverflow = _ref.preventOverflow,
    preventOverflow = _ref$preventOverflow === void 0 ? true : _ref$preventOverflow,
    _ref$overflowOverRefe = _ref.overflowOverReference,
    overflowOverReference = _ref$overflowOverRefe === void 0 ? false : _ref$overflowOverRefe,
    preventOverflowPadding = _ref.preventOverflowPadding,
    _ref$flipPopover = _ref.flipPopover,
    flipPopover = _ref$flipPopover === void 0 ? true : _ref$flipPopover,
    placement = _ref.placement,
    popoverContent = _ref.popoverContent,
    className = _ref.className,
    clickOutsidePopperHandler = _ref.clickOutsidePopperHandler,
    popperClickHandler = _ref.popperClickHandler;
  if (!referenceElement) {
    return null;
  }
  var _useState = React.useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    popperElement = _useState2[0],
    setPopperElement = _useState2[1];
  var _useState3 = React.useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    arrowElement = _useState4[0],
    setArrowElement = _useState4[1];
  var options = {
    placement: placement,
    modifiers: [{
      name: 'arrow',
      options: {
        element: arrowElement
      }
    }, {
      name: 'offset',
      options: {
        offset: popoverOffset
      }
    }, {
      name: 'preventOverflow',
      options: {
        mainAxis: preventOverflow,
        altAxis: overflowOverReference,
        padding: preventOverflowPadding
      }
    }, {
      name: 'flip',
      options: {
        flipVariations: flipPopover
      }
    }]
  };
  useClickOutside([popperElement, referenceElement], clickOutsidePopperHandler);
  var _usePopper = reactPopper.usePopper(referenceElement, popperElement, options),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  return /*#__PURE__*/React__default.createElement(popover_style.PopperWrapper, _extends({
    className: className,
    style: styles.popper
  }, attributes.popper, {
    ref: setPopperElement,
    onClick: popperClickHandler
  }), showArrow && /*#__PURE__*/React__default.createElement(popover_style.PopoverArrow, {
    theme: theme,
    ref: setArrowElement,
    arrowStyles: styles.arrow,
    popperPosition: attributes.popper ? attributes.popper['data-popper-placement'] : null
  }), popoverContent);
};

module.exports = PopperComponent;
